import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';

export default function LivePreviewPanel({
  title = '',
  caption = '',
  children,
  sx,
  flush = false,
}) {
  return (
    <Stack spacing={2}>
      {title ? (
        <Stack spacing={0.5}>
          <Stack direction="row" spacing={1} alignItems="center">
            <InsightsOutlinedIcon fontSize="small" color="action" />
            <Typography variant="subtitle1" fontWeight={700} color="text.primary">
              {title}
            </Typography>
          </Stack>
          {caption ? (
            <Typography variant="caption" color="text.secondary">
              {caption}
            </Typography>
          ) : null}
        </Stack>
      ) : null}
      <Box
        sx={{
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
          bgcolor: flush ? 'background.paper' : 'grey.50',
          px: flush ? 0 : { xs: 2, sm: 3 },
          py: flush ? 0 : { xs: 2.5, sm: 3 },
          minHeight: flush ? 0 : 280,
          display: 'flex',
          alignItems: flush ? 'stretch' : 'center',
          justifyContent: flush ? 'flex-start' : 'center',
          overflowX: 'auto',
          overflowY: 'hidden',
          ...sx?.previewCanvas,
          ...(flush ? { bgcolor: 'background.paper' } : {}),
        }}
      >
        <Box sx={{ width: '100%', minWidth: 0, ...(flush ? {} : sx?.previewCanvasInner) }}>
          {children}
        </Box>
      </Box>
    </Stack>
  );
}
